export function preserveScroll(operation: () => void, $element: JQuery, preserveX: boolean = true, preserveY: boolean = true) {
    const existingX = preserveX ? $element.scrollLeft() : 0;
    const existingY = preserveY ? $element.scrollTop() : 0;

    operation();

    if (preserveX)
        $element.scrollLeft(existingX);

    if (preserveY)
        $element.scrollTop(existingY);
}